import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_FOOD_MOOD_IMAGE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateFoodMoodImageDetailsArgs } from '../graphql/transformers'
import { UPDATE_FOOD_MOOD_IMAGE_DETAILS } from '../redux/action-types'

const useUpdateFoodMoodImageDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isImageDetailsLoading, imageDetailsError } = useSelector(
    store => store.foodMoods.foodMood,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_FOOD_MOOD_IMAGE_DETAILS_MUTATION,
        { id, data: transformToUpdateFoodMoodImageDetailsArgs(data) },
        dispatch,
        UPDATE_FOOD_MOOD_IMAGE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isImageDetailsLoading, error: imageDetailsError },
  ]
}

export default useUpdateFoodMoodImageDetailsMutation
